<template>
    <div>

        <!-- ------------------ Show Assign Truck if any --------------------------- -->
        <div v-if="orderDetailObj.transportVehicleAssignId && !onEdit">
            <Row>
                <Col span="5">Assigned to</Col>
                <Col span="10" class="assign-vehicle-detail">
                    {{orderDetailObj.truckOrder.truck.name}}
                    <Icon id="assign-edit-icon" type="md-create" @click="onEdit=true"></Icon>
                    <!--<Icon id="assign-edit-icon" type="md-trash" @click="UnassignTruck()"></Icon>-->
                    <p class="vehicle-driver-name">{{orderDetailObj.truckOrder.driverDetail.name}}</p>
                </Col>
            </Row>
        </div>
        <!-- -----------x-----------x----------x-----------x--------x---------x------ -->

        <!-- --------- If no truck assign, show list of trucks available for that Order
                       AND even show the list when change assignment(onEdit) --------  -->
<!--        <div class="fixed-height-scroll">-->
        <div v-for="(truckOrder, index) in truckOrders"
             v-if="!orderDetailObj.transportVehicleAssignId || (onEdit && truckOrder.id!==orderDetailObj.transportVehicleAssignId)">
            <Row>
                <Col span="18" class="vehicle-driver-name">
                  <span style="color: #a9a9a9; margin-right: 4px;">Transporter</span>: {{truckOrder.truck.company.name}}<br>   <!-- ↑ Exclude assignedTruckOrder from list in Edit-->
                  <span style="color: #a9a9a9; margin-right: 4px;">Driver</span>: {{truckOrder.driverDetail.name}}<br>
                  <span style="color: #a9a9a9; margin-right: 4px;">Plate No</span>: {{truckOrder.truck.platNo}}<br/>
                  <span style="color: #a9a9a9; margin-right: 4px;">Code</span>: {{truckOrder.truckOrderNumber}}
                </Col>
                <Col span="6">
                    <Poptip placement="right" v-model="popover[index]">
                        <Button class="assign-order-anchor">VIEW</Button>
                        <div slot="title">
          <span style="font-weight: bolder;font-size: 14px">
           OTHER ORDERS ({{truckOrder.orderDetailsArr.length}})</span>
                        </div>
                        <div slot="content">
                            <template v-for="order in truckOrder.orderDetailsArr">
                                {{order.order.orderNumber}}<br>
                                {{order.order.pickuppartyobject.name}} ↔ {{order.order.droppingpartyobject.name}}<br>
                                {{order.order.pickuppartyobject.address[0].city}} ↔ {{order.order.droppingpartyobject.address[0].city}}
                                <Divider></Divider>
                            </template>
                            <template v-if="!truckOrder.orderDetailsArr.length">No Orders.</template>
                            <!--<Button type="success" size="small" @click="assignTruck(truckOrder.id, index)">ASSIGN</Button>-->
                        </div>
                    </Poptip>
                    <Button type="success" style="margin-top: 2px"
                            @click="toDoStage=='assign_local_transport'?assignTruckToPickupVehicleInToDo(truckOrder.id, index):
                            assignTruck(truckOrder.id, index)">ASSIGN</Button>
                </Col>
            </Row>

            <Divider v-if="onEdit || (index+1)!==truckOrders.length"></Divider>
        </div>
<!--        </div>-->
        <!-- ------x---------x------------x---------x------------x----------x------------- -->

        <div v-if="(!orderDetailObj.transportVehicleAssignId && !truckOrders.length) ||
               (orderDetailObj.transportVehicleAssignId && truckOrders.length===1 && onEdit)">No Truck available.</div>
        <Button v-if="onEdit" @click="onEdit=false" style="font-weight: bolder;">CANCEL UPDATION</Button>


    </div>
</template>

<script>
    import {GET_TRUCK_ORDERS_BY_STATUS} from '../../graphql/queries/truckOrders'
    import {SUBSCRIBE_TRUCK_ORDERS_BY_STATUS} from '../../graphql/subscription/truckOrders'
    import {ASSIGN_TRUCK} from '../../graphql/mutations/orderDetails'
    import {ASSIGN_TRUCK_TO_PICKUPVEHICLE} from '../../graphql/mutations/orderDetails'
    import moment from 'moment'
    export default {
        apollo:{
            truckOrders: {
                query: GET_TRUCK_ORDERS_BY_STATUS,
                subscribeToMore: {
                    document: SUBSCRIBE_TRUCK_ORDERS_BY_STATUS,
                    updateQuery: function(previousResult, { subscriptionData }) {
                        this.truckOrders = subscriptionData.data.truckOrders;
                    },
                },
            },
        },
        name: "TruckAssignment",
        props:['orderDetailObj', 'toDoStage'],
        inject: ["getOrder","closeAssignVehicleDialog"],
        data: function(){
            return{
                mutation_ASSIGN_TRUCK: ASSIGN_TRUCK, /* Update OrderDetail by adding truckOrderId */
                mutation_ASSIGN_TRUCK_TO_PICKUPVEHICLE: ASSIGN_TRUCK_TO_PICKUPVEHICLE, /* Update OrderDetail by adding truckOrderId */
                truckOrders: [],
                popover: {},
                onEdit: false,   /* When need to change assignment */
            }
        },
        methods: {
            reset(){
                this.onEdit = false;
            },
            async assignTruck(truckOrderId, popoverIndex){
                let response = await this.$apollo.mutate({
                    mutation: this.mutation_ASSIGN_TRUCK, /* Update OrderDetail by adding truckOrderId */
                    variables: {
                        orderDetailId: this.orderDetailObj.id,
                        transportVehicleAssignId: truckOrderId
                    }
                })
                if(response.data){
                    this.$Message.success('Truck assigned successfully!');
                    this.popover[popoverIndex] = false;
                    this.onEdit = false;
                    this.closeAssignVehicleDialog(false)
                }
            },
            async assignTruckToPickupVehicleInToDo(truckOrderId, popoverIndex){
                let response = await this.$apollo.mutate({
                    mutation: this.mutation_ASSIGN_TRUCK_TO_PICKUPVEHICLE, /* Update OrderDetail by adding truckOrderId */
                    variables: {
                        orderDetailId: this.orderDetailObj.id,
                        pickupVehicleAssignId: truckOrderId
                    }
                })
                if(response.data){
                    this.$Message.success('Truck assigned to local transport successfully!');
                    this.popover[popoverIndex] = false;
                    this.onEdit = false;
                    this.closeAssignVehicleDialog(false)
                }
            },
            async UnassignTruck(){
                let response = await this.$apollo.mutate({
                    mutation: this.mutation_ASSIGN_TRUCK, /* Update OrderDetail by removing truckOrderId */
                    variables: {
                        orderDetailId: this.orderDetailObj.id,
                        transportVehicleAssignId: null
                    }
                })
                if(response.data){
                    this.$Message.success('Truck un-assigned successfully!');
                    this.popover[popoverIndex] = false;
                    this.onEdit = false;
                }
            }
        }
    }
</script>

<style scoped>
    .vehicle-driver-name{
        font-size: 14px;
        color: #62656b;
    }
    .assign-order-anchor{
        font-size: 12px;
        padding-left: 12px;
        font-weight: bolder;
    }
    .assign-vehicle-detail{
        border: 1px solid #d3d3d3;
        padding: 2px 0px 2px 10px;
        margin: -7px 0px 0px 0px;
    }
    #assign-edit-icon{
        visibility: hidden;
        margin-left: 4px;
    }
    .assign-vehicle-detail:hover #assign-edit-icon{
        visibility: visible;
    }
    .fixed-height-scroll{
        max-height: 200px;
        overflow-y: scroll;
    }
   /deep/ .truckOrders-ordersList-poptip>.ivu-poptip-popper>.ivu-poptip-content>.ivu-poptip-inner>.ivu-poptip-body{
        max-height: 200px;
        overflow-y: scroll;
    }
</style>
